var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2076 8.55078H14.5234V15.7087H17.2076V8.55078Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57874 8.55078H2.89453V15.7087H5.57874V8.55078Z",
    fill: "#0E5CF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1053 14.8164H2V15.7111H18.1053V14.8164Z",
    fill: "#0E5CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47656 7.67232V15.7089H8.50942V11.2352C8.5294 10.7647 8.69755 10.3232 8.97716 10.007C9.25678 9.69081 9.62516 9.52564 10.0019 9.54752C10.3782 9.52567 10.7461 9.691 11.0251 10.0073C11.304 10.3236 11.4712 10.7652 11.4901 11.2352V15.6928H13.6345V7.65625L6.47656 7.67232Z",
    fill: "#0E5CF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0547 2.28906L2 7.53042V8.55222H18.1053V7.53042L10.0547 2.28906Z",
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/Standard.4ae61c7a5758d758b312b9cff05c4076.svg";
export { ForwardRef as ReactComponent };